module.exports = __webpack_public_path__ + "img/y_2015.bd977065.png";